import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import ApiPath from "./ConstantApi";

export interface CouponData {
  code: string;
  discountType: 'percentage' | 'fixed';
  discountValue: number;
  minPurchase: number;
  maxDiscount: number;
  startDate: string;
  endDate: string;
  isActive: boolean;
  _id?: string;
}

export interface CouponResponse {
  _id: string;
  code: string;
  discountType: 'percentage' | 'fixed';
  discountValue: number;
  minPurchase: number;
  maxDiscount: number;
  startDate: string;
  endDate: string;
  isActive: boolean;
}

export interface CouponListResponse {
  data: CouponResponse[];
  totalRecords: number;
  totalPages: number;
  currentPage: number;
}

export interface CouponListParams {
  page: number;
  pageSize: number;
}

export interface UpdateCouponRequest {
  id: string;
  data: CouponData;
}

export const CouponService = createApi({
  reducerPath: "CouponsApi",
  baseQuery: RtkBaseQueryWithReauth(process.env.REACT_APP_BASE_URL || ''),
  tagTypes: ["Coupons"],
  endpoints: (builder) => ({
    getCouponList: builder.query<CouponListResponse, CouponListParams>({
      query: (params) => ({
        url: `${ApiPath.getCouponList}?page=${params.page}&pageSize=${params.pageSize}`,
        method: "GET",
      }),
      providesTags: ["Coupons"],
    }),

    addAndUpdateCoupon: builder.mutation<CouponResponse, CouponData | UpdateCouponRequest>({
      query: (payload) => {
        if ('id' in payload) {
          return {
            url: `${ApiPath.updateCoupon}/${payload.id}`,
            method: 'PUT',
            body: payload.data,
          };
        }
        return {
          url: ApiPath.createCoupon,
          method: 'POST',
          body: payload,
        };
      },
      invalidatesTags: ["Coupons"],
    }),

    deleteCoupon: builder.mutation<void, string>({
      query: (id) => ({
        url: `${ApiPath.deleteCoupon}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Coupons"],
    }),
  }),
});

export const {
  useGetCouponListQuery,
  useLazyGetCouponListQuery,
  useAddAndUpdateCouponMutation,
  useDeleteCouponMutation,
} = CouponService;